import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@totalsoft/rocket-ui';
import { ArrowBack, CloudUpload } from '@mui/icons-material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { fileType } from 'constants/fileTypes';

const HeaderLinks = props => {
  const { t } = useTranslation();
  const { onClose, onSave, allowSave, onAdd, onExport, onImport } = props;
  const [anchorEl, setShowHandleClose] = useState(null);
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setShowHandleClose(null);
  };

  const handleClick = event => {
    setShowHandleClose(event.currentTarget);
  };

  const handleExport = fileType => () => {
    onExport(fileType);
    setShowHandleClose(null);
  };
  return (
    <>
      <input
        style={{ display: 'none' }}
        value={''}
        type='file'
        id='selectFile'
        multiple
        accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
        onChange={event => onImport(event.target.files[0])}
      />
      <label htmlFor='selectFile'>
        <IconButton id={'importBtn'} component='span' fontSize='medium' color='transparent' tooltip={t('DocumentTypes.Import')}>
          <CloudUpload color='primary' />
        </IconButton>
      </label>
      <IconButton type='download' fontSize='medium' color='transparent' tooltip={t('DocumentTypes.Export')} onClick={handleClick} />
      <Menu id='render-export-menu' anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={handleExport(fileType.excel)}>{t('Authorization.Excel')}</MenuItem>
        <MenuItem onClick={handleExport(fileType.csv)}>{t('Authorization.CSV')}</MenuItem>
      </Menu>
      <IconButton fontSize='medium' color='transparent' tooltip={t('DocumentTypes.BackToList')} onClick={onClose}>
        <ArrowBack />
      </IconButton>
      <IconButton
        type='add'
        fontSize='medium'
        color='transparent'
        tooltip={t('DocumentTypes.DocumentWithAllowedStates.Add')}
        onClick={onAdd}
      />
      <IconButton
        type='save'
        fontSize='medium'
        color='transparent'
        tooltip={t('DocumentTypes.SaveChanges')}
        onClick={onSave}
        disabled={!allowSave}
      />
    </>
  );
};

HeaderLinks.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onExport: PropTypes.func.isRequired,
  onImport: PropTypes.func.isRequired,
  allowSave: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired
};

export default HeaderLinks;
